module.exports = __webpack_public_path__ + "static/img/code_img.300c6bb9.png";